import React from 'react';

const DescripcionCuenta = (props) => {
    return (
        <div className="row bottom-separator-xs">
            <div className="col-xs-12">
                <div className="row">
                    <div className="col-xs-12">
                        <label className="label-primary">Descripcion de la cuenta (para identificarla en pantalla)</label>
                    </div>
                </div>
                <label className="label-secondary" >{props.data.Descripcion}</label>
            </div>
        </div>
    );
}

export default DescripcionCuenta;